export default {
    environment: 'dev',

    videoService: {
        baseUrl: "https://video-gateway.rtl2.de/api/"
    },

    ads: true,

    ipAds: {
        baseUrl: 'https://ad-ipd.sxp.smartclip.net/select',
        zone: 'iptest',
        // zoneOverride: 'iptest/iptest'
    },

    homad: {
        active: true
    },

    // vipo: {
    //     api: 'http://vipoapi.thp.webdev.rtl2.de/video.php',
    //     vico: 'http://vipoapi.thp.webdev.rtl2.de/playlist.php',
    //     reco: 'http://vipoapi.thp.webdev.rtl2.de/playlist.php'
    // },

    ivw: {
        active: false,
        // script: 'https://script.ioam.de/iam.js',
        // iam_data: {
        //     "st":"rtl2", // site/domain
        //     "cp":"dvrsowf_ten_global_r", // code
        //     "co":"", // kommentar (request path)
        //     "sv":"ke", // FRABO Steuerung (ke/in)
        //     "sc":"yes" // Multistage Client & Visit Detection (MCVD)
        // }
    },

    googleAnalytics: {
        active: true,
        dry: false,
        debug: false,
        property: 'UA-92628984-2',
        trackingVersion: '3.1.4-dev'
    },

    ga4: {
        active: true,
        heartBeatSeconds: 5,
    },

    shadowTracking: {
        active: false,
        // url: 'https://t-rtl2de-proxy.rtl2apps.de/proxy',
    },

    agf: {
        active: true,
        // script: 'https://cdn-gl.imrworldwide.com/novms/js/2/ggcmb510.js',
        apid: 'P86657E4C-08E7-43FC-9298-1C7461DA7E0F',
        config: {
            // sfcode: 'eu-uat', // Environment to use should be 'eu-uat' during testing
            // prod: 'vc',
            // apid: 'T86657E4C-08E7-43FC-9298-1C7461DA7E0F',// Your assigned App ID
            // apn: 'RTL2Player', // Your player name
            nol_sdkDebug: 'DEBUG' //	During	testing	only,	you	can	enable	full	lo
        }
    },

    jwOptions: {
        autostart: true,
        advertising: {
            // client: 'googima',
            maxRedirects: 10,
            skipoffset: 1,
            skipmessage: 'Überspringen in XX',
            skiptext: 'Überspringen',
        },
    }
}



// WEBPACK FOOTER //
// ./src/settings/dev.settings.js